import { useContext } from 'react'
import BriefContext from '../../../Contexts/Brief'
import { GlobalBriefState } from '../../../Contexts/Brief/briefContext'

type UseBriefContext = Required<Omit<GlobalBriefState, 'geocodeError'>> &
  Pick<GlobalBriefState, 'geocodeError'>

const useBriefContext = (): UseBriefContext => {
  const briefContext = useContext(BriefContext)

  if (briefContext === undefined) {
    throw new Error('useBriefContext() must be used within BriefProvider')
  }

  return briefContext
}

export default useBriefContext
